import { render, staticRenderFns } from "./UserRatingDetails.vue?vue&type=template&id=4676cbdb&scoped=true"
import script from "./UserRatingDetails.vue?vue&type=script&lang=js"
export * from "./UserRatingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4676cbdb",
  null
  
)

export default component.exports